.root {
  min-height: 100px;
}
